import React, { useEffect } from "react";
import { useAuth } from "shared-auth";
import { FullPageSpinner } from "shared/modules/Common/FullPageSpinner";

const Logout = () => {
  const auth = useAuth();

  useEffect(() => {
    auth.signoutSilent();
  }, [auth]);

  return <FullPageSpinner />;
};

export default Logout;
